// Used as toggle buttons for registry and comments filters
// Also has functionality as a "link badge"
import React from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

// sub-components
import RegistryFilterButton from "./RegistryFilterButton/RegistryFilterButton.jsx"

import "./BadgeButton.scss"

export const colorSchemes = [
  "indigo",
  "cyan",
  "yellow",
  "magenta",
  "fuchsia",
  "purple",
  "blue",
  "mint",
  "orange",
  "brown",
  "red",
  "lime",
  "green",
  "seafoam",
  "gray",
  "charcoal",
]

const BadgeButton = ({
  label,
  url, // path to navigate to Prime location
  style = {},
  className,
  disabled,
  dataDogActionName = "",

  // filter props
  defaultFilterValue = false,
  filterValue, // for controlled component
  onChangeFilter = null, //  to use button as filter
  colorName, // for filter items
  validateStatus = "default", // "warning", "success" // on registry filters
}) => {
  const navigate = useNavigate()
  const [activeFilter, setActiveFilter] = React.useState(defaultFilterValue) // uncontrolled component

  let classNames = ["badge-button"]
  if (className) classNames.push(className)
  if (colorName) classNames.push(colorName)
  if (filterValue === true || (filterValue === undefined && activeFilter === true)) {
    classNames.push("active")
  }
  if (disabled) classNames.push("disabled")

  const onClick = () => {
    if (onChangeFilter) {
      if (filterValue === undefined) {
        setActiveFilter(!activeFilter)
      }
      onChangeFilter(label, !activeFilter)
    } else if (url) {
      navigate(url)
    } else {
      return false
    }
  }

  return (
    <span
      style={style}
      className={classNames.join(" ")}
      onClick={disabled ? null : onClick}
      data-dd-action-name={dataDogActionName}
    >
      {label}
      {validateStatus !== "default" && (
        <i
          className={`${validateStatus === "warning" ? "fal fa-exclamation-triangle warning-icon-critical" : validateStatus === "success" ? "fa-solid fa-check success-icon" : ""}`}
        />
      )}
    </span>
  )
}

// sub-component definitions
BadgeButton.RegistryFilter = RegistryFilterButton

BadgeButton.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string,
  disabled: PropTypes.bool,
  defaultFilterValue: PropTypes.bool,
  dataDogActionName: PropTypes.string,
  filterValue: PropTypes.bool,
  onChangeFilter: PropTypes.func,
  colorName: PropTypes.oneOf(colorSchemes),
  validateStatus: PropTypes.oneOf(["default", "warning", "success"]),
  style: PropTypes.object,
}

export default BadgeButton
